<div class="main-page">
  <app-common-header></app-common-header>
<div class="container">
  <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
      <br><br>
<div class=" forget-password-top">
  <div class="innerPage forget-password">
   <div class=" sigup-screen-area">
	 <span class="nav-divnk">Reset Password</span>
	 </div>
  <div class="content-part"><img src="assets/logo-5.png"></div>
      <form class="forget-password-form" [formGroup]="form" (ngSubmit)="onSubmit(form.value)" >
        <div class="form-group">
          <label for="email" class="form-label">Email</label>
          <input id="email" type="email" class="form-control email" formControlName="email" placeholder="Enter email"  [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
          <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
            <div *ngIf="f.email.errors.required">Email is required</div>
            <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
        </div>
        </div>
          <button  type="submit" class="btn btn-primary">Send</button>
          <button (click)="backButton()" class="cancel-btnss">Cancel</button>
      </form>
 </div>
</div>
</div>
</div>
